/* This file is autogenerated, see readme.md for instructions */
import ReorderSvgIcon from '@bloomreach/banana-theme/icons/reorder.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const ReorderIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <ReorderSvgIcon />
    </Icon>
  );
});

ReorderIcon.displayName = 'ReorderIcon';

export default ReorderIcon;
